<template>
  <div class="wrap">
    <car-headerbar title="编辑问卷" :isCustomLeft="isCustomLeft"/>
    <div class="content">
        <div class="question-header"  @click="editQuestion">
            <div class="title">{{ questionData.pageName}}</div>
            <div class="comment">
                <me-field
                    v-model="showCopmment"
                    autosize
                    disabled
                    type="textarea"
                    />
            </div>
        </div>
        <CarsForm
            ref="demoDynamicForm"
            class="form"
            :model="model"
            :configData="configData"
            @submitAction="submitAction"
            @operate ="operate"
        >
        </CarsForm>
        <me-button class="add-btn" block @click="add">+添加题目</me-button>
    </div>
    <me-tabbar v-model="active" class="footer-tabbar">
        <me-tabbar-item name="home" icon="add-o" @click="add">添加题目</me-tabbar-item>
        <me-tabbar-item name="search" icon="setting-o" @click="turnTo('setting')">设置</me-tabbar-item>
        <me-tabbar-item name="friends" icon="eye-o" @click="turnTo('preview')">预览</me-tabbar-item>
        <me-tabbar-item name="setting" icon="play-circle-o" @click="publish()" v-if="questionData.pageStatus === 'Unpublished'">发布</me-tabbar-item>
        <me-tabbar-item name="setting" icon="pause-circle-o" @click="stop()" v-else>暂停</me-tabbar-item>
        <me-tabbar-item name="save" icon="share-o" @click="save()">存为模版</me-tabbar-item>
    </me-tabbar>
    <TemplateSave
        v-if="createSheetShow"
        :pageId="pageId"
        :tid="tid"
        :pageName="questionData.pageName"
        :sheetShow="createSheetShow"
        @cancel ="cancelSheetShow"></TemplateSave>
  </div>
</template>

<script>

import { Toast } from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import CarsForm from 'imc-mobile/src/component/form'
import { mixin } from '@/mixins'
import { addClass2, removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import { counta } from '@/util/common'
import TemplateSave from '../compontents/save.vue'
import NativeApi from 'native-api'

export default {
    data() {
        return {
            username: '',
            active: 'home',
            model: {

            },
            isLoading: false,
            editFlag: false,
            // isMoving: false,
            // scrollY: 0,
            questionData: {},
            topicsList: [],
            configData: {
                formType: 'edit',
                form: {
                    button: false,
                    groupData: [],
                },
                api: {
                    request: {
                        submit: {
                            url: '',
                            method: 'post',
                        },
                    },
                },
            },
            isCustomLeft: false,
            needUpdateTopic: [],
            createSheetShow: false,
        }
    },
    components: {
        CarsForm,
        TemplateSave,
    },
    mixins: [mixin],
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        showCopmment() {
            return this.questionData.pageComment || '请添加说明'
        },
    },
    created() {
        const { guaguaApp } = browser
        if (guaguaApp) {
            this.isCustomLeft = guaguaApp
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState == 'visible') {
                    // 刷新
                    removeClass2('body', 'loading')
                    this.initFormData()
                }
            })
        }
        this.initFormData()
    },
    mounted() {},
    methods: {
        cancelSheetShow() {
            this.createSheetShow = false
            this.$store.commit('removeRangeList')
            this.$store.commit('updateLabelNames', [])
            this.$store.commit('removeTemplateData')
        },
        initIndex() {
            let time = 0
            let newTopicsList = this.topicsList.map((item, index) => {
                let newIndex = 0
                if (item.topicType == 'paragraph') {
                    time += 1
                }
                newIndex = index - time
                return { ...item, newIndex: newIndex }
            })
            const groupData = newTopicsList.map((item, index) => {
                const name = item.topicType == 'paragraph' ? '' : (`${item.newIndex + 1}.${item.topicName}`)

                let data = {
                    code: item.topicId,
                    topicCode: item.topicCode,
                    label: name,
                    // type: item.topicType == 'paragraph' ? 'textarea' : (item.topicType === 'textarea' &&  item.inputSize === '1' ? 'text' : item.topicType),
                    type: item.topicType == 'paragraph' ? 'textarea' : item.topicType,
                    rules: [{ required: item.required, message: `请填写${item.topicName}` }],
                    placeholder: '请输入',
                    shape: 'round',
                    props: {
                        autosize: true,
                        readonly: true,
                        placeholder: 'placeholder',
                        shape: 'round',
                    },
                    selectItem: item.selectItem,
                    skipJson: item.skipJson,
                    showJson: item.showJson,
                }
                if (item.topicType == 'textarea') {
                    // && item.inputSize
                    // data.props.rows = parseInt(item.inputSize || 1)
                    data.props.rows = 2
                } else if (item.topicType == 'paragraph') {
                    data.value = item.commonNote
                    data.rules = [{ required: false }]
                    data.props.readonly = true
                } else if(item.topicType == 'rate') {
                    data.props.componentType = 'car-rate'
                    data.props.count = item.score
                } else if(item.topicType == 'nps') {
                    data.props.componentType = 'car-nps'
                } else if (/^(radio|checkbox|matrix-rate)$/.test(item.topicType)) {
                    let option_list = item.selectItem && item.selectItem.map((cur) => {
                        const parsedChildrenData = this.parseChildrenData(cur.childrenData)
                        const childrenData = parsedChildrenData || (cur.subOption || cur.SubOption ? {
                            subOption: cur.subOption || cur.SubOption || [],
                            subOptionLeastChoose: cur.subOptionLeastChoose || cur.SubOptionLeastChoose || '不限制',
                            subOptionMostChoose: cur.subOptionMostChoose || cur.SubOptionMostChoose || '不限制',
                        } : null)
                        const data = {
                            label: cur.itemKey,
                            value: cur.itemValue,
                            childrenData,
                        }
                        let optionImg = {}
                        let isRadioOrCheckbox = /^(radio|checkbox)$/.test(item.topicType)
                        if (isRadioOrCheckbox) {
                            optionImg.thumbViewUrl = cur.thumbViewUrl
                        }
                        if (cur.itemIndex == '10000') {
                            data.slot = {
                                code: 'otherValue',
                                component: 'me-field',
                                // label: '输入框',
                                type: 'text',
                                placeholder: '请输入',
                                // rules: [{ required: true, message: '请填写详细信息' }],
                                props: {
                                    readonly: false,
                                },

                            }
                        }

                        return isRadioOrCheckbox ? {...data, ...optionImg} : data
                    })

                    data.option_list = option_list
                    data.props = {
                        max: item.mostChoose,
                        min: item.leastChoose,
                        shape: item.topicType == 'radio' ? 'round' : '',
                    }
                    // 若选择了1、2、3、4中的任何一个，则标题处显示【最少选择x项/最多选择x项/请选择1-4个选项
                    let rightText
                    if (item.leastChoose !== '不限制' && item.mostChoose !== '不限制') {
                        rightText = item.leastChoose === item.mostChoose ? `【请选择${item.leastChoose}项】` : `【请选择${item.leastChoose}-${item.mostChoose}项】`
                    } else if (item.leastChoose !== '不限制') {
                        rightText = `【至少选择${item.leastChoose}项】`
                    } else if (item.mostChoose !== '不限制') {
                        rightText = `【至多选择${item.mostChoose}项】`
                    }
                    if (item.topicType == 'radio') {
                        data.itemProps = {
                            rightIcon: {
                                component: 'me-tag',
                                text: '单选',
                                tips: '',
                                props: {
                                    type: 'success',
                                    plain: true,
                                    size: 'medium',
                                },
                            },
                        }
                    } else if (item.topicType == 'checkbox') {
                        const itemProps = {
                            rightIcon: {
                                component: 'me-tag',
                                text: '多选',
                                tips: rightText,
                                props: {
                                    type: 'success',
                                    plain: true,
                                    size: 'medium',
                                },
                            },
                        }
                        if (item.labelStyle === '1') {
                            itemProps.class = 'label-style-checkbox'
                        }
                        data.itemProps = itemProps
                    }
                    if (item.topicType === 'checkbox' && item.labelStyle === '1') {
                        data.props = {
                            ...data.props,
                            shape: '',
                        }
                    }
                }
                if(item.topicType == 'matrix-rate') {
                    data.props.componentType = 'car-matrix-rate'
                    data.props.count = item.score
                }
                return data
            })
            return groupData
        },
        parseChildrenData(data) {
            if (!data) return null
            if (typeof data === 'object') return data
            if (typeof data === 'string') {
                try {
                    const parsed = JSON.parse(data)
                    return parsed
                } catch (error) {
                    console.warn('parse childrenData error', error)
                    return null
                }
            }
            return null
        },
        initFormData() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            addClass2('body', 'loading')
            Questionnaire.getQuestionDetail(data).then((res) => {
                if (res.data.code == 'S00000') {
                    this.createSheetShow = this.$store.state.templateData.sheetShow
                    const { topicsList = [] } = res.data.data
                    this.topicsList = topicsList
                    this.questionData = res.data.data
                    this.topicsList.forEach(item=>{
                        item.showJson ? item.showJson = JSON.parse(item.showJson) : null
                    })
                    this.configData.form.groupData = this.initIndex()
                    localStorage.setItem('groupData', JSON.stringify(this.configData.form.groupData))
                    removeClass2('body', 'loading')
                    if (this.$route.query.scroll) {
                        this.$nextTick(()=>{
                            // 平滑滚动到页面的底部
                            window.scrollTo({
                            top: this.$route.query.scroll === 'add' ?  (document.body.scrollHeight || document.documentElement.scrollHeight) : this.$route.query.scroll,
                            behavior: 'smooth'
                            });
                        })
                    }
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.error(error)
            })
        },
        operateValid(editOpt) {
            let flag = true
            if (this.questionData.editStatus === '0' && editOpt !== 'edit') {
                Toast.fail('本问卷已有人作答、不允许操作')
                flag = false
            } else if (this.questionData.editStatus === '2') {
                // Toast.fail('请先暂停再编辑')
                const opts = {
                    title: '提示',
                    message: '请先【暂停】问卷，再做编辑',
                    confirmFn: () => {
                        addClass2('body', 'loading')
                        Questionnaire.questionStop({
                            tid: this.tid,
                            pageId: this.pageId,
                        }).then((res) => {
                            removeClass2('body', 'loading')
                            Toast.success('问卷已暂停')
                            if (res.data.code == 'S00000') {
                                this.initFormData()
                            }
                        }).catch((error) => {
                            removeClass2('body', 'loading')
                            Toast.fail(error.response.data.message)
                        })
                        // this.turnTo('share')
                    },
                    cancelFn: () => {
                    },
                }
                this.$_dialog(opts)

                flag = false
            }
            return flag
        },
        // 点确定或者返回 操作不一样
        editQuestion() {
            if (!this.operateValid()) {
                return
            }
            const { guaguaApp } = browser

            if (guaguaApp) {
                $CA.util.NativeAPI.invoke('createWebView', {
                    url: `${location.href.split('#')[0]}#/create/${this.pageId}`,
                })
            } else {
                this.$router.replace({
                    name: 'create',
                    params: {
                        pageId: this.pageId,
                    },
                })
            }
        },
        add() {
            this.reset()
            if (!this.operateValid()) {
                return
            }
            this.$router.push({
                name: 'choose',
                params: {
                    pageId: this.pageId
                }
            })
            // const { guaguaApp } = browser
            // if (guaguaApp) {
            //     $CA.util.NativeAPI.invoke('createWebView', {
            //         url: `${location.href.split('#')[0]}#/choose/${this.pageId}`,
            //     })
            // } else {
            //     this.turnTo('choose')
            // }
        },
        operate(e) {
            if (!this.operateValid(e.type)) {
                return
            }
            switch (e.type) {
                case 'edit':
                    this.topicEdit(e)
                    break
                case 'copy':
                    this.topicClone(e)
                    break
                case 'moveup':
                    this.topicMove(e)
                    break
                case 'movedown':
                    this.topicMove(e)
                    break
                case 'delete':
                    this.topicDelete(e)
                    break
            }
        },
        topicEdit(item) {
            if(this.editFlag) return
            this.editFlag = true
            this.reset()
            let scroll = document.querySelectorAll('.card-container')[item.itemIndex].offsetTop
            this.$router.push({
                name: 'topic2',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicsList[item.itemIndex].topicCode,
                },
                query: {
                    editStatus: this.questionData.editStatus,
                    scroll
                }
            })
        },
        reset() {
            this.$store.commit('updateShowJson', '')
            this.$store.commit('updateShowTopicList', null)
            this.$store.commit('updateShowConfirm', false)
            this.$store.commit('updateSkipObj', null)
            this.$store.commit('updateModel', null)
            this.$store.commit('updateLabelObj', null)
        },
        topicClone(item) {
            let types = []
            this.configData.form.groupData.forEach((obj) => {
                types.push(obj.type)
            })
            types.push(types[item.itemIndex])
            let num = counta(types)
            if (num > 15900) {
                Toast.fail('复制失败，数目超过最大限制')
                return
            }
            const data = {
                tid: this.tid,
                topicId: this.topicsList[item.itemIndex].topicCode,
            }
            // this.isLoading = true
            addClass2('body', 'loading')
            Questionnaire.topicClone(data)
                .then((res) => {
                    // this.isLoading = false
                    removeClass2('body', 'loading')
                    if (res.data.code == 'S00000') {
                        this.initFormData()
                    }
                })
                .catch((error) => {
                    // this.isLoading = false
                    removeClass2('body', 'loading')
                    Toast.fail(error.response.data.message)
                    console.error(error)
                })
        },
        topicDelete(item) {
            const { itemIndex } = item
            const deleteTopicCode = this.topicsList[itemIndex].topicCode
            const relationTopic = []
            for (let i=0; i<itemIndex; i++) {
                const topic = this.topicsList[i]
                const label = this.configData.form.groupData[i].label
                if (topic.skipJson && topic.skipJson.skipValue === '0') {
                    if (topic.skipJson.skipTarget === deleteTopicCode) {
                        relationTopic.push({skipValue: '0', topic: /([0-9]*)\./.exec(label)[1], index: i})
                    }
                }
                if (topic.skipJson && topic.skipJson.skipValue === '1') {
                    
                    let options = []
                    topic.selectItem.forEach((select, index) => {
                        if (select.skipTarget && select.skipTarget === deleteTopicCode) {
                            options.push(index + 1)
                        }
                    })
                    options.length ? relationTopic.push({skipValue: '1', topic: /([0-9]*)\./.exec(label)[1], options, index: i}) : null
                }
            }
            if (relationTopic.length) {
                let msg = []
                relationTopic.forEach((item) => {
                    if (item.skipValue === '0') {
                        msg.push(`第${item.topic}题`)
                    }
                    if (item.skipValue === '1') {
                        msg.push(`第${item.topic}题第【${item.options.join()}】个选项`)
                    }
                })
                this.$_dialog({
                    title: '提示',
                    message: `${msg.join('、')}设置了跳转到此题，若继续删除，跳题配置会被清空，确定删除吗？`,
                    confirmFn: () => {
                        relationTopic.forEach((item) => {
                            if (item.skipValue === '0') {
                                this.topicsList[item.index].skipJson = {}
                            }
                            if (item.skipValue === '1') {
                                item.options.forEach((option) => {
                                    const optionItem = this.topicsList[item.index].selectItem[option - 1]
                                    optionItem.skipValue = ''
                                    optionItem.skipTarget = ''
                                    optionItem.skipTo = ''
                                })
                                const hasSkipRule = this.topicsList[item.index].selectItem.some(item => item.skipTarget)
                                hasSkipRule ? null : this.topicsList[item.index].skipJson = {}
                            }
                        })
                        this.confirmTopicDelete(item)
                    },
                })
                return
            }
            // 条件显示引用判断
            const deleteTopicIndex = this.topicsList.findIndex(item => item.topicCode === deleteTopicCode)
            let showJson = null
            let str = ''
            let needUpdateTopic = []
            this.topicsList.forEach((topic, index) => {
                if (index <= deleteTopicIndex || !topic.showJson) return
                showJson = topic.showJson
                const relatedTopic = showJson.list && showJson.list.find(item => item.id === deleteTopicCode)
                if (relatedTopic) {
                    const label = this.configData.form.groupData[index].label
                    const i = label ? /([0-9]*)\./.exec(label)[1] : null
                    str += i ? `第${i}题的显示逻辑依赖于本题；` : '段落的显示逻辑依赖于本题；'
                    needUpdateTopic.push(topic)
                }
            })
            if (str) {
                this.$_dialog({
                    title: '提示',
                    message: `${str}若继续删除，依赖关系将被清空，确定删除吗？`,
                    confirmFn: () => {
                        needUpdateTopic.forEach((topic) => {
                            showJson = topic.showJson
                            const i = showJson.list.findIndex(item => item.id === deleteTopicCode)
                            showJson.list.splice(i, 1)
                        })
                        this.confirmTopicDelete(item)
                        this.updateTopic(needUpdateTopic)
                    },
                })
                return
            }
            this.confirmTopicDelete(item)
        },
        confirmTopicDelete(item) {
            const data = {
                tid: this.tid,
                topicId: this.topicsList[item.itemIndex].topicCode,
                topicsList: this.topicsList,
            }
            // this.isLoading = true
            addClass2('body', 'loading')
            Questionnaire.topicDelete(data)
                .then((res) => {
                    // this.isLoading = false
                    removeClass2('body', 'loading')
                    if (res.data.code == 'S00000') {
                        Toast.success('删除成功')
                        this.initFormData()
                    }
                })
                .catch((error) => {
                    // this.isLoading = false
                    removeClass2('body', 'loading')
                    Toast.fail(error.response.data.message)
                    console.error(error)
                })
        },
        topicMove(item) {
            const { itemIndex } = item
            let getSwitchIndex = 0 // 要交换的index
            if (item.type == 'moveup') {
                if (item.itemIndex == 0) {
                    Toast.fail('不能移动了')
                    return
                }
                getSwitchIndex = item.itemIndex - 1
                // 上移跳题校验
                const movedIndex = itemIndex - 1
                const movedTopic = this.topicsList[movedIndex]
                const label = this.configData.form.groupData[movedIndex].label
                if (movedTopic.skipJson) {
                    let { skipValue, skipTarget } = movedTopic.skipJson
                    if (skipValue === '0' && skipTarget) {
                        const targetIndex = this.topicsList.findIndex(item => item.topicCode === skipTarget)
                        if (itemIndex === targetIndex) {
                            this.$_dialog({
                                title: '提示',
                                message: `第${/([0-9]*)\./.exec(label)[1]}题设置了跳转到此题，若继续上移，跳题配置会被清空，确定上移吗？`,
                                confirmFn: () => {
                                    movedTopic.skipJson = {}
                                    this.confirmMove(item, getSwitchIndex)
                                },
                            })
                            return
                        }
                    }
                    if (skipValue === '1') {
                        let warnItem = {topic: movedTopic, select: [], selectIndex: []}
                        movedTopic.selectItem.forEach((item, index) => {
                            if (item.skipTarget) {
                                const targetIndex = this.topicsList.findIndex(topic => topic.topicCode === item.skipTarget)
                                if (itemIndex === targetIndex) {
                                    warnItem.select.push(item)
                                    warnItem.selectIndex.push(index + 1)
                                }
                            }
                        })
                        if (warnItem.selectIndex.length) {
                            this.$_dialog({
                                title: '提示',
                                message: `第${/([0-9]*)\./.exec(label)[1]}题第【${warnItem.selectIndex.join()}】个选项设置了跳转到此题，若继续上移，跳题配置会被清空，确定上移吗？`,
                                confirmFn: () => {
                                    const { select, topic } = warnItem
                                    select.forEach((item) => {
                                        item.skipTarget = ''
                                        item.skipValue = ''
                                        item.skipTo = ''
                                    })
                                    const hasSkipRule = topic.selectItem.some(item => item.skipTarget)
                                    hasSkipRule ? null : topic.skipJson = {}
                                    this.confirmMove(item, getSwitchIndex)
                                },
                            })
                            return
                        }
                    }
                }
                // 上移显示条件校验
                const upTopic = this.topicsList[movedIndex]
                const currentTopic = this.topicsList[itemIndex]
                let needUpdateTopic = []
                if (currentTopic.showJson) {
                    const showJson = currentTopic.showJson
                    const topic = showJson.list && showJson.list.find(item => item.id === upTopic.topicCode)
                    needUpdateTopic.push(currentTopic)
                    if (topic) {
                        const i = /([0-9]*)\./.exec(label)[1]
                        let str = `本题的显示逻辑依赖于第${i}题；`
                        this.$_dialog({
                            title: '提示',
                            message: `${str}若继续上移，依赖关系将被清空，确定上移吗？`,
                            confirmFn: () => {
                                const i = showJson.list.findIndex(item => item.id === upTopic.topicCode)
                                showJson.list.splice(i, 1)
                                this.confirmMove(item, getSwitchIndex)
                                this.updateTopic(needUpdateTopic)
                            },
                        })
                        return
                    }
                }
            }
            if (item.type == 'movedown') {
                if (item.itemIndex == this.topicsList.length - 1) {
                    Toast.fail('不能移动了')
                    return
                }
                getSwitchIndex = item.itemIndex + 1
                // 下移跳题校验
                const movedownTopic = this.topicsList[itemIndex]
                const movedIndex = itemIndex + 1
                if (movedownTopic.skipJson) {
                    let { skipValue, skipTarget } = movedownTopic.skipJson
                    if (skipValue === '0' && skipTarget) {
                        const targetIndex = this.topicsList.findIndex(item => item.topicCode === skipTarget)
                        if (movedIndex === targetIndex) {
                            this.$_dialog({
                                title: '提示',
                                message: `跳题逻辑必须设置为跳到本题后面的题目。   继续下移，跳题逻辑将被清空，确定下移吗？`,
                                confirmFn: () => {
                                    movedownTopic.skipJson = {}
                                    this.confirmMove(item, getSwitchIndex)
                                },
                            })
                            return
                        }
                    }
                    if (skipValue === '1') {
                        let warnItem = {topic: movedownTopic, select: [], selectIndex: []}
                        movedownTopic.selectItem.forEach((item, index) => {
                            if (item.skipTarget) {
                                const targetIndex = this.topicsList.findIndex(topic => topic.topicCode === item.skipTarget)
                                if (movedIndex === targetIndex) {
                                    warnItem.select.push(item)
                                    warnItem.selectIndex.push(index + 1)
                                }
                            }
                        })
                        if (warnItem.selectIndex.length) {
                            this.$_dialog({
                                title: '提示',
                                message: `跳题逻辑必须设置为跳到本题后面的题目。   继续下移，第【${warnItem.selectIndex.join()}】个选项跳题逻辑将被清空，确定下移吗？`,
                                confirmFn: () => {
                                    const { select, topic } = warnItem
                                    select.forEach((item) => {
                                        item.skipTarget = ''
                                        item.skipValue = ''
                                        item.skipTo = ''
                                    })
                                    const hasSkipRule = topic.selectItem.some(item => item.skipTarget)
                                    hasSkipRule ? null : topic.skipJson = {}
                                    this.confirmMove(item, getSwitchIndex)
                                },
                            })
                            return
                        }
                    }
                }
                //下移显示条件校验
                const nextTopic = this.topicsList[movedIndex]
                let needUpdateTopic = []
                if (nextTopic.showJson) {
                    const showJson = nextTopic.showJson
                    const topic = showJson.list && showJson.list.find(item => item.id === movedownTopic.topicCode)
                    needUpdateTopic.push(nextTopic)
                    if (topic) {
                        const label = this.configData.form.groupData[getSwitchIndex].label
                        const i = label ? /([0-9]*)\./.exec(label)[1] : null
                        let str = i ? `第${i}题的显示逻辑依赖于本题；` : '段落的显示逻辑依赖于本题；'
                        this.$_dialog({
                            title: '提示',
                            message: `${str}若继续下移，依赖关系将被清空，确定下移吗？`,
                            confirmFn: () => {
                                const i = showJson.list.findIndex(item => item.id === movedownTopic.topicCode)
                                showJson.list.splice(i, 1)
                                this.confirmMove(item, getSwitchIndex)
                                this.updateTopic(needUpdateTopic)
                            },
                        })
                        return
                    }
                }
            }
            this.confirmMove(item, getSwitchIndex)
        },
        confirmMove(item, getSwitchIndex) {
            this.topicsList.forEach((topic) => {
                topic.showJson ? topic.showJson = JSON.stringify(topic.showJson) : null
            })

            const handleTopicsList = this.topicsList.map((topic) => {
                if (['radio', 'checkbox'].indexOf(topic.topicType) != -1) {
                    return {
                        ...topic,
                        selectItem: JSON.stringify(topic.selectItem.map(n => {
                            delete n.imgUrl 
                            delete n.thumbViewUrl
                            delete n.itemUrl
                            return n
                        })),
                        skipJson: topic.skipJson ? JSON.stringify(topic.skipJson) : topic.skipJson
                    }
                }
                return {
                    ...topic,
                    selectItem: JSON.stringify(topic.selectItem),
                    skipJson: topic.skipJson ? JSON.stringify(topic.skipJson) : topic.skipJson
                }
            })

            const data = {
                tid: this.tid,
                topicId: this.topicsList[item.itemIndex].topicCode,
                switchTopicId: this.topicsList[getSwitchIndex].topicCode,
                topicsList: handleTopicsList,
            }
            // this.isLoading = true
            addClass2('body', 'loading')
            // this.isMoving = true
            // this.scrollY = window.pageYOffset || window.scrollY
            Questionnaire.topicMove(data)
                .then((res) => {
                    // this.isLoading = false

                    removeClass2('body', 'loading')
                    if (res.data.code == 'S00000') {
                        Toast.success('操作成功')
                        this.initFormData()
                    }
                })
                .catch((error) => {
                    // this.isLoading = false
                    removeClass2('body', 'loading')
                    Toast.fail(error.response.data.message)
                    console.error(error)
                })
        },
        updateTopic(topicList) {
            topicList.forEach((item) => {
                if (!item.showJson) return
                let showJson = typeof item.showJson === 'string' ? JSON.parse(item.showJson) : item.showJson
                showJson = showJson.list && showJson.list.length ? showJson : ''
                item.showJson = showJson ? JSON.stringify(showJson) : ''
            })
            const data = {
                tid: this.tid,
                pageId: this.pageId,
                topicList,
            }
            Questionnaire.updateShowJson(data).catch((error) => {
                // this.isLoading = false
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
                console.error(error)
            })
        },
        turnTo(routerName) {
            const { guaguaApp } = browser
            if (guaguaApp) {
                $CA.util.NativeAPI.invoke('createWebView', {
                    url: `${location.href.split('#')[0]}#/${routerName}/${this.pageId}`,
                })
            } else {
                this.$_push(routerName, this.pageId)
            }
        },
        publish() {
            this.$router.push({
                name: 'publish',
                params: {
                    pageId: this.pageId,
                },
            })
        },
        stop() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            const options = {
                title: '提示',
                message: '暂停后问卷将无法填写，确定吗？',
                confirmFn: () => {
                    addClass2('body', 'loading')
                    Questionnaire.questionStop(data).then((res) => {
                        removeClass2('body', 'loading')
                        if (res.data.code == 'S00000') {
                            Toast.success('问卷已暂停')
                            this.initFormData()
                        }
                    }).catch((error) => {
                        removeClass2('body', 'loading')
                        console.log(error.response)
                        Toast.fail(error.response.data.message)
                    })
                },
            }
            this.$_dialog(options)
        },
        save() {
            this.createSheetShow = true
        },
        submitAction(res) {
            console.log('提交表单  这里不需要')
        },
    },
}
</script>
<style lang="scss" scoped>
    .wrap{
        position: relative;
        // background: #F2F4F6;
        height: 100%;
        .content{
            // height: calc(100% - 50px);
            // overflow-y: scroll;
            // -webkit-overflow-scrolling: touch;
            padding: 12px;
            .add-btn{
                border-radius: 6px;
                background: #fff;
                height: 52px;
                margin-top: 12px;
                margin-bottom: 60px;
                color: #06B455;
                border: none;
            }
        }

        .footer-tabbar{
            height: 64px;
            margin: 0 12px;
            width: calc(100% - 24px);
            border-radius: 6px;
            box-sizing: border-box;
            position: fixed;
            z-index: 110;
            bottom: 0;
        }
    }
    ::v-deep .comment{
        textarea{
            font-size: 14px;
        }
    }
    ::v-deep .card-container{
        .title{
            top: 12px;
            margin-right: 0;
        }
        .me-icon-ellipsis{
            padding: 10px;
        }
    }
    ::v-deep .dynamic-form-container{
        padding: 0;
        // background: #fff;
        .card-container{
            margin-bottom: 12px;
            border-radius: 6px;
        }
         .dynamic-form-fielditem::after{
            border: none;
        }
        .dynamic-form-fielditem{
            border-radius: 6px;
            overflow: hidden;
            .me-field__label{
                padding: 12px 0;
                margin-bottom: 0;
            }
            .me-cell--required::before{
                top: 25px;
                left: 8px;
            }
            .me-checkbox-group{
                width: 100%;
                .me-cell{
                    min-height: 24px;
                    line-height: 24px;
                    padding: 0 12px;
                }
            }
            .me-radio-group {
                width: 100%;
                .me-radio {
                    width: 100%;
                }
                .me-radio__label{
                    width: 100%;
                }
            }
            .me-radio__label{
                display: flex;
                align-items: center;
                // .me-radio__label,span{
                //     min-width: 30px;
                // }
                > div:first-child {
                    align-items: center !important;
                    width: 100%;
                    justify-content: space-between;
                }
                > div > span:first-child{
                    min-width: 30px;
                    flex: 1;
                    + span {
                        width: 200px;
                    }
                }
                .me-cell{
                    padding: 0 12px;
                }
            }
            .me-cell{
              line-height: 24px;
            }
            .me-cell__title{
                font-size: 14px;
                font-weight: bold;
                color:#222;
                line-height: 26px;
                padding: 0;
                padding-right: 20px;
                margin: 12px 0 0;
            }
            .me-cell__value--alone {
                textarea[readonly="readonly"]{
                    margin-top: 32px;
                    padding-left: 0;
                    background: #fff;
                    color: #9298A8;
                    font-size: 14px;
                    margin-bottom: 0;
                    line-height: 24px;
                }
            }
            .me-field__body{
                input,textarea {
                    background: #F6F6F6;
                    line-height: 36px;
                    border-radius: 6px;
                    padding-left: 16px ;
                }

                .me-field__control--custom {
                    // .me-checkbox__label{
                    //     min-width: 30px;
                    // }
                    .me-checkbox {
                        flex: 1;
                        + span {
                            width: 200px;
                        }
                    }
                    >div {
                        >div {
                            // height: 52px;
                            margin-top: 0;
                            padding: 12px 0;
                            align-items: center !important;
                            justify-content: space-between;
                            width: 100%;
                        }
                    }
                }
            }
            // 处理错误信息显示距离问题
            .me-field__body + .van-field__error-message{
                margin-top: 10px;
            }
            .me-field--min-height .me-field__control{
                min-height: 36px;
            }
        }
    }
    ::v-deep .label-style-checkbox {
        .checkbox-wrap {
            width: auto !important;
            padding: 0 !important;
        }
        .me-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            gap: 12px 12px;
        }
        .me-checkbox {
            background: #F2F4F6;
            border-radius: 4px;
            padding: 10px 16px;
            font-family: PingFangSC, 'PingFang SC', sans-serif;
            font-weight: 400;
            font-size: 14px;
            color: #424B58;
            margin-right: 0;
            border: none;
            display: inline-flex;
            align-items: center;
        }
        .me-checkbox__icon {
            display: none;
        }
        .me-checkbox__label {
            width: auto;
            margin: 0;
            text-align: center;
        }
        .me-checkbox--checked {
            background: #05B555;
            color: #FFFFFF;
        }
        .me-checkbox--checked .me-checkbox__label {
            color: #FFFFFF;
        }
    }
    ::v-deep .me-icon-eye-o {
        font-size: 26px;
    }
</style>
<style lang="scss" scoped>
.me-popover{
    left: 225px !important;
}
</style>
